export default {
  computed: {
    marketplaceUser () {
      return !this.$store.state.header?.headerData?.isElite ?? false
    }
  }
}
